<template>
  <div class="wrap">
    <div class="title">
      <div>
        <van-icon name="arrow-left" size="20" style="margin-left: 10px" @click="onClickLeft" />
      </div>
      <div>{{ chatDetail.nickname }}</div>
      <div>
        <van-icon name="ellipsis" size="22" style="margin-right: 10px" @click="onClickRight" />
      </div>
    </div>
    <div class="good">
      <a :href="chatDetail.url" v-if="chatDetail.url" class="good_title">{{ chatDetail.goods_des }}</a>
      <div v-else class="good_title">{{ chatDetail.goods_des }}</div>
      <div>{{ chatDetail.trade_price }}</div>
      <div class="trade_des">{{ chatDetail.trade_express }}</div>
      <div class="good_status">
        <div class="trade_des">
          {{ chatDetail.trade_des }}
        </div>
        <van-button round size="mini" v-if="chatDetail.button_des=== '修改价格'"  @click="showPrice=true">
          {{ chatDetail.button_des }} (可修改)
        </van-button>
        <van-button round size="mini" v-else-if="chatDetail.button_des">
          {{ chatDetail.button_des }}
        </van-button>
      </div>
    </div>
    <div class="content_box" id="box" ref="scrollBox" @click="focus=false">
      <div class="timer">{{ chatDetail.created_at }}</div>
      <div v-for="(item, index) in chatDetail.chat" :key="index">
        <div v-if="item.type === 1" class="userbox2">
          <div class="nameInfo2">
            <div style="font-size: 14px">{{ chatDetail.nickname }}</div>
            <div class="contentText2">{{ item.content }}</div>
          </div>
          <div>
            <van-image round width="50px" height="50px" src="https://bpic.51yuansu.com/pic3/cover/02/75/66/5a360cce68711_610.jpg" />
          </div>
        </div>
        <div v-else-if="item.type === 2" class="userbox">
          <div class="nameInfo">
            <div style="font-size: 14px">我</div>
            <div class="contentText">{{ item.content }}</div>
          </div>
          <div>
            <van-image round width="50px" height="50px" src="https://tm-image.tianyancha.com/tm/269c4dfd90d5d5ded1c0d7405ff57819.jpg" />
          </div>
        </div>
        <div v-else>
          <div class="nameInfo_sys">
            <div class="contentText_sys">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-field v-model="inputValue" :focus="focus" @keydown="sendMsg($event)" center type="textarea" :autosize="{ maxHeight: 100, minHeight: 25 }" placeholder="请输入内容" rows="1">
        <template #button>
          <van-button type="primary" @click="handdleMsg">发送</van-button>
          <van-button size="mini" type="primary" @click="more">快捷回复</van-button>
        </template>
      </van-field>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '90%' }">
      <van-tabs v-model="active">
        <van-tab v-for="(item, key, index) in msgList" :key="index" :title="key">
          <van-cell v-for="(item2, index2) in item" :title="(item2.keyword ? '[' + item2.keyword + ']' : '') + item2.msg" :key="index2" is-link @click=";(show = false), (inputValue = item2.msg)">
            <!--             <template #right-icon>
              <van-icon name="delete-o" @click.stop="deleteMsg(item2.id)" />
            </template> -->
          </van-cell>
        </van-tab>
      </van-tabs>
      <div style="font-size: 10px; color: #969799; text-align: center; margin-top: 20px" @click="showDialog = true">添加快捷回复内容</div>
    </van-popup>
    <van-dialog v-model="showDialog" title="添加快捷回复内容" show-cancel-button @confirm="addMsg">
      <van-field name="radio" label="单选框">
        <template #input>
          <van-radio-group v-model="type" direction="horizontal">
            <van-radio name="书相关">书相关</van-radio>
            <van-radio name="发货相关">发货相关</van-radio>
            <van-radio name="其他">其他</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="keyword" name="关键字" label="关键字" placeholder="关键字 同时包含多个用|分割" />
      <van-field v-model="msg" name="内容" label="内容" placeholder="请输入快捷回复内容" />
    </van-dialog>
    <van-dialog v-model="showPrice" title="修改价格" show-cancel-button @confirm="editPrice" >
      <van-field v-model="price" label="价格(元)" placeholder="请输入价格(元)" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: '',
      type: '',
      keyword: '',
      active: 0,
      price: 0,
      show: false,
      focus: false,
      showPrice: false,
      showDialog: false,
      msgList: {},
      chatDetail: {},
      // 输入内容
      inputValue: '',
      // 滚动条距离顶部距离
      scrollTop: 0
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getChatDetail()
    this.msgList = JSON.parse(sessionStorage.getItem('msgList'))
    this.uuid = sessionStorage.getItem('uuid')
  },
  methods: {
    async getMsgList() {
      const { data: res } = await this.$http.get('msg/list?uuid=' + this.uuid)
      sessionStorage.setItem('msgList', JSON.stringify(res.data))
      this.msgList = res.data
    },
    async deleteMsg(id) {
      const { data: res } = await this.$http.get('msg/delete?id=' + id + '&uuid=' + this.uuid)
      if (res.code === 200) {
        this.$toast('删除成功')
        this.getMsgList()
      }
    },
    async addMsg() {
      const { data: res } = await this.$http.get('msg/create?type=' + this.type + '&uuid=' + this.uuid + '&keyword=' + this.keyword + '&msg=' + this.msg)
      if (res.code === 200) {
        this.$toast('添加成功')
        this.getMsgList()
      }
    },
    // 加载选择对象的最新的联系人列表
    sendMsg(event) {
      console.log(event)
      if (event.keyCode === 13) {
        event.preventDefault ? event.preventDefault() : (event.returnValue = false)
        this.handdleMsg()
      }
    },
    more() {
      this.show = true
    },
    // 发送和接收消息
    handdleMsg() {
      const obj = {
        nickname: '',
        content: this.inputValue,
        p_des: '',
        type: 2
      }
      if (this.inputValue.slice(0, 4) === 'http') {
        this.inputValue = this.inputValue.replace('_b', '')
      }
      this.chatDetail.chat.push(obj)
      const that = this
      console.log(that.global.ws)
      if (that.global.ws && that.global.ws.readyState === 1) {
        const data = {
          type: 'command',
          uid: this.chatDetail.xianyu_account_id + '',
          data: {
            type: 'send_msg',
            nickname: this.chatDetail.nickname,
            content: this.inputValue,
            p_des: ''
          }
        }
        that.global.ws.send(JSON.stringify(data))
      }
      this.inputValue = ''
    },
    editPrice() {
      const that = this
      console.log(that.global.ws)
      if (that.global.ws && that.global.ws.readyState === 1) {
        const data = {
          type: 'command',
          uid: this.chatDetail.xianyu_account_id + '',
          data: {
            type: 'editPrice',
            nickname: this.chatDetail.nickname,
            content: this.price
          }
        }
        that.global.ws.send(JSON.stringify(data))
      }
      this.inputValue = ''
    },
    async getChatDetail() {
      const { data: res } = await this.$http.get('goofish/chat/detail?id=' + this.id)
      if (res.code === 200) {
        console.log(res)
        this.chatDetail = res.data
      }
    },
    // 返回
    onClickLeft() {
      this.$router.back()
    },
    // 更多
    onClickRight() {
      console.log('按钮')
    }
  }
}
</script>

<style  lang="less" scoped>
.wrap {
  height: 100%;
  width: 100%;
  position: relative;
}
.title {
  height: 40px;
  width: 100%;
  background-color: #eaeaea;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.good {
  padding: 8px 6px;
  text-align: left;
  background-color: #c2c2c2;
  border: #c0bdbc 2px;
  .good_title {
    font-size: 12px;
  }
  .good_status {
    display: flex;
    justify-content: space-between;
  }
}
.trade_des {
  font-size: 8px;
}
.bottom {
  min-height: 50px;
  width: 100%;
  border-top: 1px solid #eaeaea;
  position: fixed;
  bottom: 0;
}
.content_box {
  height: calc(100% - 115px);
  overflow: auto;
  padding: 10px;
  padding-bottom: 80px;
}
.timer {
  text-align: center;
  color: #c2c2c2;
}

/* 发送的信息样式 */
.userbox {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}
.nameInfo {
  /* 用flex：1把盒子撑开 */
  flex: 1;
  margin-right: 10px;
  /* 用align-items把元素靠右对齐 */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.contentText {
  background-color: #9eea6a;
  /* 把内容部分改为行内块元素，因为盒子flex：1把盒子撑大了，所以用行内块元素让内容宽度不根据父盒子来 */
  display: inline-block;
  /* 这四句是圆角 */
  border-top-left-radius: 10px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  /* 最大宽度限定内容输入到百分61换行 */
  max-width: 61%;
  padding: 5px 10px;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  margin-top: 3px;
  font-size: 14px;
}

.nameInfo_sys {
  margin: 12px 0;
  /* 用flex：1把盒子撑开 */
  flex: 1;
  margin-right: 10px;
  /* 用align-items把元素靠右对齐 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentText_sys {
  color: #c0bdbc;
  background-color: #fffefa;
  /* 把内容部分改为行内块元素，因为盒子flex：1把盒子撑大了，所以用行内块元素让内容宽度不根据父盒子来 */
  display: inline-block;
  /* 这四句是圆角 */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  /* 最大宽度限定内容输入到百分61换行 */
  max-width: 61%;
  padding: 5px 10px;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  margin-top: 3px;
  font-size: 14px;
}

/* 接收的信息样式 */
.userbox2 {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 10px;
}
.nameInfo2 {
  /* 用flex：1把盒子撑开 */
  flex: 1;
  margin-left: 10px;
}
.contentText2 {
  background-color: #9eea6a;
  /* 把内容部分改为行内块元素，因为盒子flex：1把盒子撑大了，所以用行内块元素让内容宽度不根据父盒子来 */
  display: inline-block;
  /* 这四句是圆角 */
  border-top-left-radius: 0px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  /* 最大宽度限定内容输入到百分61换行 */
  max-width: 61%;
  padding: 5px 10px;
  /* 忽略多余的空白，只保留一个空白 */
  white-space: normal;
  /* 换行显示全部字符 */
  word-break: break-all;
  margin-top: 3px;
  font-size: 14px;
}
</style>
